import type { ReactElement } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { SessionStatus, selectStatus, useSession } from "./session";

export const RequireAuth = (): ReactElement | null => {
  const status = useSession(selectStatus);
  const location = useLocation();

  if (status === SessionStatus.RESTORING) return null;

  if (status !== SessionStatus.AUTHENTICATED) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};
